import UserDriverListRequest, {
  UserDriverListRequestQueryParams,
} from "./user-driver-list.request";

const createQueryParams = (
  data: UserDriverListRequest,
): UserDriverListRequestQueryParams => {
  return {
    firstName: data.firstName,
    fleetPartner: data.fleetPartner,
    fleetPartnerId: data.fleetPartnerId,
    lastName: data.lastName,
    limit: data.limit,
    offset: data.offset,
    order: data.order,
    statusCriteria: data.statusCriteria,
    taxiCorporation: data.taxiCorporation,
    taxiCorporationId: data.taxiCorporationId,
    address: data.address,
    creationEnd: data.creationEnd,
    creationStart: data.creationStart,
    modificationEnd: data.modificationEnd,
    modificationStart: data.modificationStart,
    email: data.email,
    pendingCandidature: data.pendingCandidature,
    username: data.username,
  };
};

const userDriverListRequestFactory = {
  createQueryParams,
};

export default userDriverListRequestFactory;
